import { Container, LinkButton } from '@cluey/cluey-components';

import { PageTitle } from '../../../components/hub/PageTitle';
import BasePageLayout from '../../../templates/BasePageLayout/BasePageLayout';
import { getWebsiteDomainByCountry } from '../../../util/helper/website';
import { PATH_HUB_HOME, PATH_HUB_PLAN_DETAILS } from '../../../util/pagePath';
import useChangePricingPlanContext, { DisabledTransitionPlans } from './useChangePricingPlanContext';

const TransitionDisabled = () => {
  const { accountDetails, currentPricingPlan } = useChangePricingPlanContext();

  const renderContent = () => {
    switch (currentPricingPlan?.pricingPlanName as DisabledTransitionPlans) {
      case DisabledTransitionPlans.Saver23:
      case DisabledTransitionPlans.Saver2307:
        const serviceFee = getWebsiteDomainByCountry(accountDetails?.country);
        return (
          <>
            <p>
              Great news! You are already on the plan that provides you with the best possible value. As a loyal and
              valued customer, we have kept your session price the same, despite price increases for other customers. As
              a result, you have the most flexibility with your sessions that we can offer, as well as a lower price per
              session than any of our newer customers.
            </p>
            <p>
              You can view our current prices{' '}
              <a
                href={`${serviceFee}/service-fees`}
                className="text-blue-5 underline underline-offset-2"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
              .
            </p>
            <p>Thank you for being part of the Cluey community!</p>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <BasePageLayout>
      <Container className="flex flex-col gap-y-5">
        <PageTitle
          title="Cluey plans"
          className="!pb-10"
          breadcrumbs={[{ label: 'Account', to: PATH_HUB_PLAN_DETAILS }]}
        />
        {renderContent()}
        <LinkButton appearance="reverse" size="xs" className="mt-3 w-[100px]" to={PATH_HUB_HOME}>
          Home
        </LinkButton>
      </Container>
    </BasePageLayout>
  );
};

export default TransitionDisabled;
